import { Operator } from '@ardoq/api-types';
import {
  QueryBuilderFilterDefinition,
  QueryBuilderFilterDefinitionGroup,
} from './types';
import { compact } from 'lodash';
import { isExclusivelyPerspectivesOperator } from '../types';

const filterGroupsToFilters = (
  filterGroups: QueryBuilderFilterDefinitionGroup[]
) => filterGroups.flatMap(({ filters }) => filters);

export const findFilterDefinitionByName = (
  filterGroups: QueryBuilderFilterDefinitionGroup[],
  filterName: string | undefined
) => filterGroupsToFilters(filterGroups).find(({ id }) => id === filterName);

export const toOption = (
  label: string,
  value?: string,
  description?: string
) => ({
  label,
  value: value || label,
  description,
});

export const replaceNonPerspectiveOperators = (
  filterDefinition: QueryBuilderFilterDefinition
) => ({
  ...filterDefinition,
  operators: compact(
    filterDefinition.operators.map(operator => {
      if (operator === Operator.CONTAINS_SUBSTRING) return Operator.CONTAINS;
      else if (operator === Operator.NOT_CONTAINS_SUBSTRING)
        return Operator.NOT_CONTAINS;
      else if (
        operator === Operator.DO_NOT_USE_CONTAINS_PHRASE ||
        operator === Operator.DO_NOT_USE_NOT_CONTAINS_PHRASE ||
        operator === Operator.BETWEEN
      )
        return null;
      return operator;
    })
  ),
});

export const removePerspectiveOperatorsFromFilter = (
  filterDefinition: QueryBuilderFilterDefinition
): QueryBuilderFilterDefinition => ({
  ...filterDefinition,
  operators: filterDefinition.operators.filter(
    operator => !isExclusivelyPerspectivesOperator(operator)
  ),
});
